var Theme = (function ($, UIkit) {
  var $html = $("html"),
    $body = $("body"),
    $sticky = $(".js-sticky-menu"),
    $header = $("#header"),
    transition = 850,
    mobile_break = 992,
    filledClass = "form-field--is-active",
    activeClass = "form-field--is-active";

  /**
   * Initialize...
   */
  function init() {
    /*
|--------------------------------------------------------------------------
| ACCORDION VIDEO CONTROL
|--------------------------------------------------------------------------
*/
    // document.addEventListener("DOMContentLoaded", () => {
    //   const players = {};

    //   // Ensure all iframes are initialized
    //   const iframes = document.querySelectorAll("iframe.vimeo-player");
    //   iframes.forEach((iframe) => {
    //     const id = iframe.id;
    //     if (!players[id]) {
    //       players[id] = new Vimeo.Player(iframe);
    //     }
    //   });

    //   document.querySelectorAll('button[data-toggle="tab"]').forEach((button) => {
    //     button.addEventListener("click", () => {
    //       const targetSelector = button.getAttribute("data-target");
    //       if (!targetSelector) return;

    //       const match = targetSelector.match(/#tab-([\w-]+)-card-(\d+)/);
    //       if (!match) return;

    //       const sectionId = match[1];
    //       const panelIndex = match[2];
    //       const iframeId = `vimeo-${sectionId}-${panelIndex}`;

    //       console.log("Pausing", id);

    //       // ✅ Pause all other videos — only if not already paused
    //       Object.entries(players).forEach(([id, player]) => {
    //         if (id !== iframeId) {
    //           player.getPaused().then((isPaused) => {
    //             if (!isPaused) {
    //               player.pause().catch(() => {});
    //             }
    //           }).catch(() => {});
    //         }
    //       });

    //       console.log("Playing", iframeId);
    //       // ✅ Play selected video
    //       const selectedPlayer = players[iframeId];
    //       if (selectedPlayer) {
    //         selectedPlayer.setMuted(true)
    //           .then(() => selectedPlayer.play())
    //           .catch((err) => {
    //             console.warn(`Play failed for ${iframeId}`, err);
    //           });
    //       }
    //     });
    //   });
    // });
    // END VIDEOS

    // Build TOC nav from content
    if ($("body").hasClass("single-post")) {
      $("body").append(
        '<div role="progressbar" class="progress-container" artia-hidden="true"><div class="progress js-progress"></div></div>'
      );
      if ($(".post-content h2").length === 0) {
        $(".js-nav-toc").remove();
      } else {
        if ($(".js-nav-toc").length) {
          $.each($(".post-content h2"), function (index, value) {
            if ($(this).text().length) {
              $(".js-nav-toc").append(
                '<a class="nav-item" href="#heading-' +
                  (index + 1) +
                  '">' +
                  $(this).text() +
                  "</a>"
              );
              $(this).html(
                '<div id="heading-' +
                  (index + 1) +
                  '">' +
                  $(this).html() +
                  "</div>"
              );
            }
          });

          //var $toc = $body.find('.js-nav-toc').closest('.widget');
          //$body.find('.js-nav-toc-clone').html($toc.html());
        }
      }

      /**
       * Blog progress bar... (AI generated)
       */
      var $progressBar = $(".js-progress");
      var $postContent = $(".post-content");
      var $header = $(".header"); // Get the fixed header element
      var postOffsetTop, postHeight, scrollableDistance, headerHeight;

      function updateScrollableDistance() {
        headerHeight = $header.outerHeight(); // Get the height of the fixed header
        postOffsetTop = $postContent.offset().top - headerHeight; // Get the top position of the post-content relative to the document, accounting for header
        postHeight = $postContent.outerHeight(); // Get the total height of the post content
        // Calculate the scrollable distance when the bottom of post-content reaches the top of the viewport, accounting for header
        scrollableDistance = postOffsetTop + postHeight;
        //scrollableDistance = postOffsetTop + postHeight - headerHeight;
        $progressBar.parent().css("top", headerHeight);
        $("html").css("scroll-behavior", "smooth");
        $("html").css("scroll-padding-top", headerHeight + 6);
      }

      function updateProgressBar() {
        var scrollTop = $(window).scrollTop(); // Get the current scroll position

        // Only calculate the progress if the scroll is within the .post-content area
        if (scrollTop >= postOffsetTop && scrollTop <= scrollableDistance) {
          var progress =
            (scrollTop - postOffsetTop) / (scrollableDistance - postOffsetTop); // Calculate the scroll percentage

          // Ensure progress is between 0 and 1
          progress = Math.min(Math.max(progress, 0), 1);

          // Update the progress bar using transform scaleX
          $progressBar.css("transform", "scaleX(" + progress + ")");
        } else if (scrollTop < postOffsetTop) {
          // If the user is above .post-content, reset the progress bar
          $progressBar.css("transform", "scaleX(0)");
        } else {
          // If the user is past .post-content, set the progress bar to 100%
          $progressBar.css("transform", "scaleX(1)");
        }
      }

      // Throttle function to optimize scroll events
      function throttle(fn, wait) {
        var lastTime = 0;
        return function () {
          var now = new Date().getTime();
          if (now - lastTime >= wait) {
            lastTime = now;
            fn();
          }
        };
      }

      // Initial calculation (on load to wait for responsive image heights)
      $(window).on("load", function () {
        updateScrollableDistance();
        updateProgressBar(); // Update the progress bar to reflect new dimensions
        $progressBar.parent().addClass("anim-fade");

        // Scroll to hash w/ offset since anchors are js created...
        if (location.hash.length !== 0) {
          var target = $(".post-content").find(location.hash);
          if (target.length) {
            $(window).scrollTop(target.offset().top - 126);
          }
        }
      });

      // Update progress bar on scroll
      $(window).on("scroll", throttle(updateProgressBar, 100)); // Throttled at 100ms

      // Recalculate scrollable height on window resize
      $(window).on("resize", function () {
        updateScrollableDistance();
        updateProgressBar(); // Update the progress bar to reflect new dimensions
      });
    }

    // Individual Video w/Modal
    // if($('.js-video')) {

    //   // Carousel video modals
    //   $('.js-modal-vid').on('show.bs.modal', function () {
    //     var vid = $(this).find('iframe');
    //     vid.attr('src', vid.data('src'));
    //   });

    //   $('.js-modal-vid').on('hidden.bs.modal', function () {
    //     $(this).find('iframe').removeAttr('src');
    //   });
    // }

    // Section Video Carousel SINGLE
if ($('.js-swiper-video-single').length) {
  const swiperVideoSingle = new Swiper('.js-swiper-video-single', {
    parallax: true,
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 400,
    threshold: 10,
    watchOverflow: true,
    coverflowEffect: { rotate: 0, stretch: 0, depth: 450, modifier: 0.8, slideShadows: false },
    pagination: false
  });

  // Expose Swiper constructor once
  if (!window.Swiper) window.Swiper = swiperVideoSingle.constructor;

  // Carousel video modals
  $('.js-modal-swiper-vid').on('show.bs.modal', function () {
    var vid = $(this).find('iframe');
    vid.attr('src', vid.data('src'));
  });
  $('.js-modal-swiper-vid').on('hidden.bs.modal', function () {
    $(this).find('iframe').removeAttr('src');
  });
}

// Section Video Carousel (multi)
if ($('.js-swiper-video').length) {
  const $carousel = $('.js-swiper-video');
  const autoplayMuted =
    $carousel.data('autoplay-muted') === true || $carousel.data('autoplay-muted') === 'true';

  const swiperVideoMulti = new Swiper('.js-swiper-video', {
    parallax: true,
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 1.9,
    spaceBetween: 400,
    loop: true,
    loopAdditionalSlides: 2,
    threshold: 10,
    slideToClickedSlide: true,
    coverflowEffect: { rotate: 0, stretch: 0, depth: 450, modifier: 0.8, slideShadows: false },
    pagination: { el: '.swiper-pagination', clickable: true },
    breakpoints: {
      1800: { spaceBetween: 300, slidesPerView: 1.7 },
      991:  { spaceBetween: 200, slidesPerView: 1.6 },
      767:  { spaceBetween: 100, slidesPerView: 1.2 }
    }
  });

  if (!window.Swiper) window.Swiper = swiperVideoMulti.constructor;

  // === INNOVATIONS WYSIWYG SLIDER =============================================
  (function initInnovationsSwiper(){
    function initIfReady(attempt){
      var $containers = $('.innovations-swiper');
      if (!$containers.length) return;

      // Wait until the constructor is exposed (should be by now, but this is safe)
      if (typeof window.Swiper !== 'function') {
        return setTimeout(function(){ initIfReady((attempt||0)+1); }, Math.min(200*(attempt||0)+50, 600));
      }

      $containers.each(function(){
        var el = this;
        if (el.swiper || el.classList.contains('swiper-initialized') || el.classList.contains('swiper-container-initialized')) {
          return;
        }

        var inst = new Swiper(el, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 30,
          pagination: { el: el.querySelector('.swiper-pagination'), clickable: true },
          autoplay: { delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true },
          observer: true, observeParents: true
        });

        if (inst.autoplay && typeof inst.autoplay.start === 'function') {
          inst.autoplay.start();
        }

        // Optional equalize
        function equalizeSlide(slideEl){
          if (!slideEl) return;
          var mqDesktop = window.matchMedia('(min-width: 992px)').matches;
          var media = slideEl.querySelector('.media-inner');
          var box   = slideEl.querySelector('.trendz .box');
          if (!media || !box) return;
          box.style.minHeight = '';
          if (mqDesktop) {
            var h = Math.round(media.getBoundingClientRect().height);
            if (h > 0) box.style.minHeight = h + 'px';
          }
        }
        function equalizeVisible(){
          ['.swiper-slide-active', '.swiper-slide-next', '.swiper-slide-prev'].forEach(function(cls){
            equalizeSlide(el.querySelector(cls));
          });
        }
        equalizeVisible();
        inst.on('slideChangeTransitionEnd', equalizeVisible);
        window.addEventListener('resize', equalizeVisible);
      });
    }

    // run after load to ensure ACF block exposed constructor
    if (document.readyState === 'complete') { initIfReady(0); }
    else { $(window).on('load', function(){ initIfReady(0); }); }
  })();

  // --- existing Vimeo/overlay logic (unchanged) ---
  let firstSlideTime = 0;
  let hasPlayedFirstSlide = false;

  if (autoplayMuted) {
    setTimeout(() => {
      const $firstSlide = $carousel.find('.swiper-slide').eq(0);
      const $iframe = $firstSlide.find('iframe.vimeo-player.default');
      if ($iframe.length) {
        const player = new Vimeo.Player($iframe[0]);
        player.setVolume(0);
        player.play().then(() => {
          hasPlayedFirstSlide = true;
          $firstSlide.find('.video-swipe-overlay').show();
        }).catch((err) => { console.warn('Autoplay inline video failed:', err); });
      }
    }, 1000);
  }

  swiperVideoMulti.on('slideChange', () => {
    const activeIndex = swiperVideoMulti.realIndex;
    $carousel.find('.swiper-slide').each(function () {
      const $slide = $(this);
      const $iframe = $slide.find('iframe.vimeo-player');
      if ($iframe.length) {
        const player = new Vimeo.Player($iframe[0]);
        const isActive = $slide.hasClass('swiper-slide-active');
        const isFirstSlide = $iframe.hasClass('default');

        if (isFirstSlide && !isActive) {
          player.getCurrentTime().then((time) => { firstSlideTime = time; });
          player.pause().catch(() => {});
          $iframe.css('pointer-events', 'none');
          $slide.find('.video-swipe-overlay').show();

          const wrapper = $iframe[0].closest('.video-wrapper');
          if (wrapper) {
            const playBtn = wrapper.querySelector('.play-toggle');
            const playIcon = playBtn ? playBtn.querySelector('i') : null;
            if (playIcon) { playIcon.classList.remove('fa-pause'); playIcon.classList.add('fa-play'); }
            if (playBtn) {
              playBtn.style.opacity = '1';
              playBtn.style.visibility = 'visible';
              playBtn.style.pointerEvents = 'auto';
            }
          }
        }

        if (isFirstSlide && isActive) {
          player.setCurrentTime(firstSlideTime).catch(() => {});
          player.pause().catch(() => {});
          $iframe.css('pointer-events', 'none');
          $slide.find('.video-swipe-overlay').show();
        }

        if (!isFirstSlide) {
          player.pause().catch(() => {});
          $iframe.css('pointer-events', 'none');
        }
      }
    });
  });

  $carousel.on('click', '.play-toggle', function () {
    const $slide = $(this).closest('.swiper-slide');
    const $iframe = $slide.find('iframe.vimeo-player');
    const player = new Vimeo.Player($iframe[0]);
    $iframe.css('pointer-events', 'auto');
    $slide.find('.video-swipe-overlay').hide();
    player.play().catch(() => {});
  });

  $('.js-modal-swiper-vid').on('show.bs.modal', function () {
    const vid = $(this).find('iframe');
    vid.attr('src', vid.data('src'));
  });
  $('.js-modal-swiper-vid').on('hidden.bs.modal', function () {
    $(this).find('iframe').removeAttr('src');
  });
}
// END VID CAROUSEL


    if ($(".js-section-vid").length) {
      $(".js-vid-play").on("click", play_vid);

      window.addEventListener(
        "resize",
        function (event) {
          var $vid = $body.find(".vid-embed > div:hidden iframe");
          if ($vid.length) {
            var src = $vid.attr("src");
            $vid.attr("src", src.replace("&autoplay=1", ""));
          }
        },
        true
      );
    }

    if (!window.navigator.userAgent.includes("Lighthouse")) {
      $(window).on("load", function () {
        if (
          !document.cookie.match(
            /^(.*;)?\s*wordpress_cookie_policy\s*=\s*[^;]+(.*)?$/
          )
        ) {
          $(".js-cookie-alert").removeClass("d-none");
        }
      });
    }

    $(".js-cookie-alert").on("closed.bs.alert", function () {
      let now = Date.now();
      document.cookie =
        "wordpress_cookie_policy=" +
        now +
        ";max-age=604800;path=/;SameSite=Strict";
    });

    $("[data-modal-vid]").on("click", function (e) {
      e.preventDefault();
      var vid = $(this).data("modal-vid");
      $(".js-modal-vid iframe").attr(
        "src",
        "https://player.vimeo.com/video/" + vid + "?autoplay=1"
      );
      $(".js-modal-vid").modal("toggle");
    });

    $(".js-modal-vid").on("hidden.bs.modal", function () {
      $(this).find("iframe").removeAttr("src");
    });

    $(".navbar-toggler").on("click", function () {
      $($(this).attr("data-target")).attr(
        "style",
        "background-image:url(" +
          $($(this).attr("data-target")).attr("data-src") +
          ");"
      );
    });

    $(".js-nav-search").on("click", function () {
      $(".overlay-search").attr(
        "style",
        "background-image:url(" + $(".overlay-search").attr("data-src") + ");"
      );
      //$('.overlay-search').attr('aria-hidden', 'false');
    });

    $("#careersModal").on("hidden.bs.modal", function (e) {
      let $iframe = $(e.currentTarget).find("iframe");
      $iframe.attr("src", $iframe.attr("src"));
    });

    // Checks for IE
    is_ie();

    if ($(".js-prlx").length !== 0) {
      prlx();
    }

    // Check for mobile orientation
    //watch_orientation();

    // Handle #hashes in url and scroll-to hash
    if (!$("body").hasClass("single-post")) {
      handle_hashes();
    }

    // Set action triggers
    set_triggers();

    // Assign components
    assign_components();

    lazy_load();

    // Remove Marketo styles (so we can style forms how we want)
    if (typeof MktoForms2 !== "undefined") {
      MktoForms2.whenReady(function (form) {
        remove_marketo_styles();
      });

      // Add listener whenRendered as this even fires on layout change of marketo selectbox to remove styles
      MktoForms2.whenRendered(function (form) {
        remove_marketo_styles();
      });
    }

    setTimeout(function () {
      $("svg").on("click", '[data-toggle^="info-"]', function () {
        $(".info")
          .not("." + $(this).data("toggle"))
          .removeClass("active");
        $("." + $(this).data("toggle")).toggleClass("active");
      });

      $(".values-pie-chart")
        .find("svg")
        .on(
          {
            mouseenter: function () {
              //$('.values-pie-chart').find('svg').append($(this)); // Fixes zindex but breaks transitions
              $("svg").find(".js-pie-group.active").removeClass("active");
              $(this).addClass("active");

              $(".career-values .col-12.fade").removeClass("anim-fade");
              setTimeout(function () {
                $(".career-values .col-12.fade").addClass("anim-fade");
              }, 50);

              $(".js-pie-title").attr(
                "style",
                "color:" +
                  $("svg").find(".js-pie-group.active .pie-path").attr("fill") +
                  "!important"
              );
              $(".js-pie-title").text($(this).find(".title").text());
              $(".js-pie-desc").text($(this).find(".desc").text());
            },
            mouseleave: function () {},
          },
          ".js-pie-group"
        );
    }, 1000);

    $(".modal").on("show.bs.modal", function () {
      $(this)
        .find("img")
        .each(function () {
          $(this).attr("src", $(this).data("src"));
        });
    });

    $("#contact-us-modal").on("shown.bs.modal", function (e) {
      if ($("#contact-us-modal .mktoButton").length == 0) {
        MktoForms2.loadForm(
          "//app-ab28.marketo.com",
          "578-UTL-676",
          1194,
          function (form) {
            form.onSuccess(function (form, redirectUrl) {
              var url = redirectUrl.split("?");
              var redirectNew =
                "https://www.waystar.com/contact-us/thank-you/?" + url[1];
              location.href = redirectNew;
              return false;
            });
          }
        );
      }
    });
  }

  /**
   * Play inline video
   */
  let play_vid = function () {
    var $section_vid = $(this).closest(".js-section-vid");
    $section_vid.find(".section-img").addClass("fade");
    $section_vid.find(".section-overlay").addClass("fade");

    var $vid = $section_vid.find(".vid-embed > div:visible iframe");
    if ($vid.length) {
      var src = $vid.attr("src");
      $vid.attr("src", src + "&autoplay=1");
    }

    var $vid = $section_vid.find(".vid-embed > div:hidden iframe");
    if ($vid.length) {
      var src = $vid.attr("src");
      $vid.attr("src", src.replace("&autoplay=1", ""));
    }
  };

  function prlx() {
    // Parallax
    var scene = $(".js-prlx").get(0);
    var prlx_init = new Parallax(scene, {
      clipRelativeInput: true,
      scalarY: 20,
    });
    var scene2 = $(".js-prlx").get(1);
    var prlx_init2 = new Parallax(scene2, {
      clipRelativeInput: true,
      scalarY: 20,
      scalarX: 6,
    });

    // Rptate
    var box = $(".js-compass");
    var boxCenter = [
      box.offset().left + box.width() / 2,
      box.offset().top + box.height() / 2,
    ];

    document.addEventListener(
      "mousemove",
      function (e) {
        //var angle = Math.atan2(e.pageX - boxCenter[0], -(e.pageY - boxCenter[1])) * (180/Math.PI);
        var angle =
          Math.atan2(e.pageX - boxCenter[0], -(e.pageY - boxCenter[1])) *
          (90 / Math.PI);
        box.css({ "-webkit-transform": "rotate(" + angle + "deg)" });
        box.css({ "-moz-transform": "rotate(" + angle + "deg)" });
        box.css({ transform: "rotate(" + angle + "deg)" });
      },
      { passive: true }
    );
  }

  /**
   * Check for IE!
   * @note Adds classes to `html` to target unsupported css
   */
  function is_ie() {
    var agent = window.navigator.userAgent,
      browser = agent.indexOf("MSIE");

    if (browser > 0) {
      var ver = parseInt(
        agent.substring(browser + 5, agent.indexOf(".", browser))
      );
      $html.addClass("is_ie is_ie_" + ver);

      return false;
    } else if (!!navigator.userAgent.match(/Trident\/7\./)) {
      $html.addClass("is_ie is_ie_11");

      return false;
    } else if (/Edge\/\d./i.test(agent)) {
      $html.addClass("is_ie is_edge");

      return false;
    }

    return false;
  }

  /**
   * Watch device for orientation change
   * @note The design of some page parts do not
   * lend themselves very well to landscape orientation
   */
  function watch_orientation() {
    window.addEventListener(
      "resize",
      function () {
        adjust_for_orientation();
      },
      false
    );

    adjust_for_orientation();
  }

  /**
   * Watch device orientation
   * @todo `window.orientation` is deprecated, currently works but need another way...
   */
  function adjust_for_orientation() {
    // Add alert when a device changes orientation to landscape
    if (Math.abs(window.orientation) === 90) {
      $body.append(
        '<div class="js-rotate"><div><i class="icon far fa-sync-alt fa-fw fa-2x"></i></div><div>Please rotate your device</div></div>'
      );
    } else {
      $body.find(".js-rotate").remove();
    }
  }

  /**
   * Handle hashes on load and in links
   */
  function handle_hashes() {
    // Scroll to hash on page load
    $(window).on("load", function () {
      var hash = window.location.hash;
      if (hash.length) {
        scroll_to_offset($(hash));
      }
    });

    //Scroll to hash on click
    $("a[href*='#']")
      .not("[href='#']")
      .not("[data-toggle='tab']")
      .click(function () {
        if (
          location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") ||
          location.hostname == this.hostname
        ) {
          var target = $(this.hash);
          target = target.length
            ? target
            : $("[name=" + this.hash.slice(1) + "]");
          if (target.length) {
            scroll_to_offset(target);
          }
        }
      });
  }

  /*
   * Set site triggers and toggles
   */
  function set_triggers() {
    // Toggle offcanvas
    $('[data-toggle="offcanvas"]').on("click", function () {
      $body.toggleClass("nav-open");
    });

    // Toggle subnav on or off
    $('[data-toggle="subnav"]').on("click", function () {
      $body.toggleClass("subnav-open");
    });

    // Close subnav
    $('[data-toggle="subnav-off"]').on("click", function () {
      $body.removeClass("subnav-open");
    });
  }

  /**
   * Assign components
   */
  function assign_components() {
    /**
     * Set blur/focus behavior of all inputs/textareas
     */
    $(".gfield input, .gfield textarea").each(function () {
      const input = $(this);
      const parent = input.closest(".gfield");
      console.log(input);

      setActive(input, parent);

      input.blur(function (e) {
        let input = $(e.currentTarget),
          parent = input.closest(".gfield");
        setActive(input, parent);
      });

      input.focus(function (e) {
        let input = $(e.currentTarget),
          parent = input.closest(".gfield");
        // console.log(input, parent);
        // setActive(input, parent);
        parent.addClass(activeClass);
      });
    });
  }

  /**
   * Remove Marketo styles
   */
  function remove_marketo_styles() {
    $('.mktoLabel[style="width: 0px;"]').addClass("d-none");
    $(
      "#mktoForms2BaseStyle, #mktoForms2ThemeStyle, .mktoClear, .mktoGutter, .mktoOffset, .mktoForm style"
    ).remove();
    $(".mktoForm, .mktoButtonWrap, .mktoFormCol, .mktoHasWidth")
      .removeAttr("style")
      .removeClass("mktoHasWidth");
    $(".mktoHasWidthktoFormRow input:hidden")
      .parent()
      .removeClass("mktoFormRow")
      .css("display", "none");
    $(".mktoHtmlText span").find("a").removeAttr("id");

    $(".mktoField").each(function () {
      if ($(this).hasClass("mktoRequired") && $(this).attr("id")) {
        $("label[for=" + $(this).attr("id") + "] .mktoAsterix").replaceWith(
          '<span class="asterisk">*</span>'
        );
      } else if ($(this).attr("id")) {
        $("label[for=" + $(this).attr("id") + "] .mktoAsterix").remove();
      }

      let $input = $(this),
        $wrapper = $input.parent(),
        fieldType = $input[0].tagName.toLowerCase(),
        className =
          "mktoFieldWrap" +
          fieldType.substr(0, 1).toUpperCase() +
          fieldType.substr(1);

      $wrapper.addClass(className);

      $input
        .on("blur", function (e) {
          let input = $(e.currentTarget),
            wrapper = input.parent();
          setActive(input, wrapper);
        })
        .on("focus", function (e) {
          $wrapper.addClass(activeClass);
        });
    });
  }

  function setActive($el, $wrapper) {
    $wrapper.removeClass(activeClass);
    if ($el.val() === "") {
      $wrapper.removeClass(filledClass);
    } else {
      $wrapper.addClass(filledClass);
    }
  }

  /**
   * Scroll to target
   * @returns {boolean}
   */
  function scroll_to_offset(target) {
    $("html,body").animate(
      {
        scrollTop: target.offset().top - get_top_offset(),
      },
      transition,
      "swing"
    );

    return false;
  }

  /**
   * Get top offset for animating scroll
   * @returns {*}
   */
  function get_top_offset() {
    if ($body.width() > mobile_break) {
      var sticky_height = $sticky.hasClass("uk-active uk-sticky")
        ? $sticky.height()
        : 123;

      return $header.height() + sticky_height;
    }

    return $header.height();
  }

  return {
    init: init,
  };
})(jQuery, UIkit);

jQuery(document).ready(function () {
  Theme.init();
  function carouselNormalization() {
    (window.heights = []), //create empty array to store height values
      window.tallest; //create variable to make note of the tallest slide

    function normalizeHeights() {
      jQuery(".carousel-inner .carousel-item").each(function () {
        //add heights to array
        window.heights.push(jQuery(this).outerHeight());
      });
      window.tallest = Math.max.apply(null, window.heights); //cache largest value
      jQuery(".carousel-inner .carousel-item").each(function () {
        jQuery(this).css("min-height", tallest + "px");
      });
    }
    normalizeHeights();

    jQuery(window).on("resize orientationchange", function () {
      (window.tallest = 0), (window.heights.length = 0); //reset vars
      jQuery(".carousel-inner .carousel-item").each(function () {
        jQuery(this).css("min-height", "0"); //reset min-height
      });

      normalizeHeights(); //run it again
    });
  }

  jQuery(document).ready(function () {
    carouselNormalization();
  });

  // Allow links to work in toggle buttons

  // jQuery('body').find('button[data-toggle="tab"]').on('click', function(e) {
  //   if(e.target.getAttribute('href')) {
  //     e.preventDefault();
  //     window.location.href = e.target.getAttribute('href');
  //   }else{
  //     if(jQuery(this).hasClass('active')) {
  //       e.stopPropagation();
  //       jQuery('#tab-1-item-init').tab('show');
  //     }
  //   }
  // });

  // For Muliple accordions on one page ie: #tab-1a
  jQuery("body").on("click", 'button[data-toggle="tab"]', function (e) {
    const $btn = jQuery(this);

    // ✅ If the target of the click is an actual link inside the tab button — let it be
    if (jQuery(e.target).closest("a").length) {
      return; // Allow normal link behavior
    }

    const target = $btn.data("target");
    if (!target) return;

    const $targetPane = jQuery(target);
    const isActive = $btn.hasClass("active");

    if (isActive) {
      // Collapse: deactivate everything in this group
      const tabPrefixMatch = $btn.attr("id").match(/^(tab-[\w\d]+)-item/);
      if (!tabPrefixMatch) return;

      const tabPrefix = tabPrefixMatch[1];

      // Deactivate current active tab and content
      jQuery(`#${tabPrefix} .nav-link`).removeClass("active");
      jQuery(
        `#tab-content-${tabPrefix.replace("tab-", "")} .tab-pane`
      ).removeClass("show active");

      // Optionally: trigger a hidden default/init tab (if needed)
      const $initBtn = jQuery(`#${tabPrefix}-item-init`);
      if ($initBtn.length) {
        $initBtn.addClass("active");
        jQuery($initBtn.data("target")).addClass("show active");
      }

      return false;
    }

    // Let Bootstrap handle activating the clicked tab normally
  });
});

/**
 * Lazy load images
 *
 * @selector img.js-lazy
 */
function lazy_load() {
  let imgs = [].slice.call(document.querySelectorAll("img.js-lazy"));
  let observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        let img = entry.target;

        img.src = img.dataset.src;

        if (img.dataset.srcset) {
          img.srcset = img.dataset.srcset;
        }

        img.classList.remove("js-lazy");
        img.classList.remove("lazy");
        img.classList.add("anim-fade");

        observer.unobserve(img);
      }
    });
  });

  imgs.forEach((img) => {
    observer.observe(img);
  });

  document.addEventListener("DOMContentLoaded", lazy_load, true);
}

/*
|--------------------------------------------------------------------------
| FORM CONTROL
|--------------------------------------------------------------------------
*/
//
//
// /**
//  * Get the input or textarea
//  * @param el
//  * @returns {any}
//  */
// const getInput = (el) => {
//     return el.querySelector('input') !== null ? el.querySelector('input') : el.querySelector('textarea');
// }
//
// const closestParent  = (elem, className) => {
//     for (let el = elem; el; el = el.parentElement) {
//         // If the element has the class, return it
//         if (el.classList.contains(className)) {
//             return el;
//         }
//     }
//     // If no element with the class is found, return null
//     return null;
// }
//
// const setActive = ($el, $wrapper) => {
//     $wrapper.removeClass(activeClass);
//     if ($el.val() === '') {
//         $wrapper.removeClass(filledClass);
//     } else {
//         $wrapper.addClass(filledClass);
//     }
// }
// /**
//  * Set blur/focus behavior of all inputs/textareas
//  */
// [].forEach.call(
//     document.querySelectorAll('.gfield input, .gfield textarea'),
//     (el) => {
//         const input  = el;
//         const parent = closestParent(el, '.gfield');
//         console.log(input);
//
//         Theme.setActive(el, parent);
//
//         input.onblur = () => {
//             Theme.setActive(el, parent)
//         }
//         input.onfocus = () => {
//             Theme.setActive(el, parent)
//         }
//     }
// );

/**
 * Handle input masking for phone field
 */
// if (document.querySelector('.acf-field[data-name="phone"]')) {
//     let wrapper = document.querySelector('.acf-field[data-name="phone"]');
//
//     wrapper.querySelector('input').onkeyup = (e) => {
//         let x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
//         e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
//     }
// }
